﻿import angular from "angular";
import "./api/cart";

import "./datastorage";

angular
  .module("folkeuni")
  .factory("Cart", function (CartApi, DataStorage, $q, $cookies, $rootScope) {
    var cart = this;

    cart.add = function (cartObj) {
      var deferred = $q.defer();
      CartApi.add(cartObj).then(
        function (response) {
          deferred.resolve(response.data);
        },
        function (errorResponse) {
          deferred.reject(errorResponse);
        }
      );
      return deferred.promise;
    };

    cart.checkout = function (cartObj) {
      var deferred = $q.defer();

      CartApi.checkout(cartObj).then(
        function (cartObj) {
          deferred.resolve(cartObj.data);
        },
        function (res) {
          deferred.reject(res);
        }
      );
      return deferred.promise;
    };

    cart.customerInfoLocalStorageClear = function () {
      localStorage.removeItem("customerInfo");
    };

    cart.customerInfoLocalStorageSet = function (cartObj) {
      if (cartObj && cartObj.checkout) {
        // Brug students direkte hvis det findes
        if (Array.isArray(cartObj.checkout.students)) {
          DataStorage.set("customerInfo", JSON.stringify(cartObj.checkout));
          return;
        }
        // Udtræk students (kun place/number, uden id)
        var students = [];
        if (cartObj.products) {
          // Find max antal student discounts på ét produkt
          var max = 0;
          cartObj.products.forEach(function (product) {
            if (product.discount && Array.isArray(product.discount)) {
              var count = product.discount.filter(function (d) {
                return d.type === "Student";
              }).length;
              if (count > max) max = count;
            }
          });
          // Tag værdier fra første produkt med studierabat
          var firstProduct = (cartObj.products || []).find(function (p) {
            return p.discount && p.discount.some(function (d) {
              return d.type === "Student";
            });
          });
          if (firstProduct && firstProduct.discount) {
            var studentDiscounts = firstProduct.discount.filter(function (d) {
              return d.type === "Student";
            });
            for (var i = 0; i < max; i++) {
              students.push({
                place: studentDiscounts[i] ? studentDiscounts[i].place : "",
                number: studentDiscounts[i] ? studentDiscounts[i].number : "",
              });
            }
          } else {
            for (var i = 0; i < max; i++) {
              students.push({ place: "", number: "" });
            }
          }
        }
        cartObj.checkout.students = students;
        // Udtræk tickets (organization tickets) som før
        var tickets = [];
        if (cartObj.products) {
          cartObj.products.forEach(function (product) {
            if (product.organization && Array.isArray(product.tickets)) {
              product.tickets.forEach(function (ticket) {
                tickets.push({
                  id: ticket.id,
                  organization: ticket.organization,
                  jobTitle: ticket.jobTitle,
                });
              });
            }
          });
        }
        cartObj.checkout.tickets = tickets;
        DataStorage.set("customerInfo", JSON.stringify(cartObj.checkout));
      }
    };

    cart.customerInfoLocalStorageGet = function (cartObj) {
      var result = null;
      return new Promise((resolve, reject) => {
        DataStorage.get("customerInfo").then(
          (data) => {
            result = data;
            try {
              var parsed = JSON.parse(data);
              if (parsed && cartObj) {
                cartObj.checkout = parsed;
              }
              // Restore students (student discounts) by index
              if (parsed && parsed.students && cartObj && cartObj.products) {
                cartObj.products.forEach(function (product) {
                  if (product.discount && Array.isArray(product.discount)) {
                    var studentDiscounts = product.discount.filter(function (d) {
                      return d.type === "Student";
                    });
                    studentDiscounts.forEach(function (discount, idx) {
                      if (parsed.students[idx]) {
                        discount.place = parsed.students[idx].place;
                        discount.number = parsed.students[idx].number;
                      } else {
                        discount.place = "";
                        discount.number = "";
                      }
                    });
                  }
                });
              }
              // Restore tickets (organization tickets) as before
              if (parsed && parsed.tickets && cartObj && cartObj.checkout) {
                cartObj.checkout.tickets = parsed.tickets;
                if (cartObj.products) {
                  cartObj.products.forEach(function (product) {
                    if (product.organization && Array.isArray(product.tickets)) {
                      product.tickets.forEach(function (ticket) {
                        var match = cartObj.checkout.tickets.find(function (t) {
                          return t.id === ticket.id;
                        });
                        if (match) {
                          ticket.organization = match.organization;
                          ticket.jobTitle = match.jobTitle;
                        }
                      });
                    }
                  });
                }
              }
            } catch (e) {}
            resolve(result);
          },
          function (message) {
            reject(message);
          }
        );
      });
    };

    cart.paymentMethods = [
      {
        value: "Invoice",
        label: "Faktura",
      },
      {
        value: "Card",
        label: "Med kort",
      },
    ];

    cart.paymentMethodGetByValue = function (id) {
      for (var i in cart.paymentMethods) {
        var currentPaymentMethod = cart.paymentMethods[i];
        if (currentPaymentMethod.value == id) {
          return currentPaymentMethod;
        }
      }

      return null;
    };

    cart.read = function () {
      var deferred = $q.defer();
      CartApi.read().then(
        function (response) {
          deferred.resolve(response.data);

          $rootScope.$broadcast("cart.update", response.data);
        },
        function (res) {
          deferred.reject(res);
        }
      );
      return deferred.promise;
    };

    cart.hasOrganizationTickets = function (cart) {
      for (var i in cart.products) {
        if (cart.products[i].organization) {
          return true;
        }
      }
    };

    cart.hasStudentTickets = function (cart) {
      var hasStudendDiscount = false;

      for (var i in cart.products) {
        var currentProduct = cart.products[i];

        for (var y in currentProduct.discount) {
          var currentDiscount = currentProduct.discount[y];

          if (currentDiscount.type == "Student") {
            hasStudendDiscount = true;
            break;
          }
        }
        if (hasStudendDiscount) {
          break;
        }
      }
      return hasStudendDiscount;
    };

    cart.update = function (cardUpdateObj) {
      var deferred = $q.defer();
      CartApi.update(cardUpdateObj).then(
        function (response) {
          deferred.resolve(response.data);
          $rootScope.$broadcast("cart.update", response.data);
        },
        function (errorResponse) {
          deferred.reject(errorResponse);
        }
      );
      return deferred.promise;
    };

    cart.validate = function (cartObj) {
      var deferred = $q.defer();

      CartApi.validate(cartObj).then(
        function (cartObj) {
          deferred.resolve(cartObj.data);
        },
        function (res) {
          deferred.reject(res);
        }
      );

      return deferred.promise;
    };

    cart.voucherValidate = function (voucherObj) {
      var deferred = $q.defer();

      CartApi.voucherValidate(voucherObj).then(
        function (voucherObj) {
          deferred.resolve(voucherObj.data);
        },
        function (res) {
          deferred.reject(res);
        }
      );

      return deferred.promise;
    };

    cart.reset = function () {
      var deferred = $q.defer();

      CartApi.reset().then(
        function (res) {
          deferred.resolve(res);
        },
        function (res) {
          deferred.reject(res);
        }
      );
    };

    cart.waitlistSubscribe = function (waitlistObj) {
      var deferred = $q.defer();

      CartApi.waitlistSubscribe(waitlistObj).then(
        function (result) {
          deferred.resolve(result.data);
        },
        function (res) {
          deferred.reject(res);
        }
      );

      return deferred.promise;
    };

    return cart;
  });
